module.exports = __webpack_public_path__ + "icon-fb.b3d7e820b237c588caf1.png";


//////////////////
// WEBPACK FOOTER
// /home/runner/work/ucla-prrla/ucla-prrla/ucla-prrla/src/assets/img/icon-fb.png
// module id = ../../../../../src/assets/img/icon-fb.png
// module chunks = 2